<template>
	<div class="padding-lg" v-loading="loadingPage">
		<div class="text-xxl">{{ $route.meta.title }}</div>
		<div class="padding-top-xl">
			<div class="flex justify-between">
				<div style="width: 580px;">
					<el-card class="box-card">
						<div slot="header" class="flex align-center justify-between">
							<div>
								<span class="el-icon-search"></span>
								<span class="text-bold margin-left-sm">合同分类</span>
							</div>
							<div>
								<el-button type="success" round size="mini" @click="showDialogAdd = true">
									<span class="el-icon-plus"></span>
									添加分类
								</el-button>
							</div>
						</div>
						<el-tree
							:data="infos"
							:expand-on-click-node="false"
							:props="{ label: 'name' }"
							:default-expand-all="true"
							:highlight-current="true"
							node-key="id"
							:current-node-key="info_class.id"
							@node-click="handleNodeClick"
							:indent="0"
							:draggable="true"
							class="tree-line"
						></el-tree>
					</el-card>
				</div>
				<div style="width: 100%;" class="margin-left-lg">
					<el-card class="box-card" :body-style="{ padding: 0 }">
						<div slot="header" class="clearfix">
							<div class="flex justify-between align-center">
								<div class="flex align-center">
									<span class="el-icon-search"></span>
									<span class="text-bold margin-left-sm">{{ info_class.name }}</span>
									<span class="padding-left-xs text-grey">[ {{ info_class.id }} ]</span>
								</div>
								<div class="flex align-center">
									<el-button type="success" round size="mini" @click="showDialogModify = true">
										<span class="el-icon-edit"></span>
										修改
									</el-button>
								</div>
							</div>
						</div>
						<div class="padding-xl">
							<div class="infoshow">
								<div class="title">名称：</div>
								<div class="con">{{ info_class.name }}</div>
							</div>
							<div class="infoshow">
								<div class="title">状态：</div>
								<div class="con">
									<span class="cu-tag bg-green round" v-if="info_class.stateflag == 1">生效</span>
									<span class="cu-tag bg-grey round" v-else>无效</span>
								</div>
							</div>
							<div class="infoshow">
								<div class="title">添加时间：</div>
								<div class="con">{{ info_class.addtime }}</div>
							</div>
						</div>
					</el-card>
				</div>
			</div>
		</div>
		<el-dialog title="添加分类" :visible.sync="showDialogAdd" width="400px">
			<el-form :model="formAdd" ref="formAdd" label-width="60px" label-suffix=":">
				<el-form-item label="名称" prop="name" :rules="{ required: true, message: '请输入名称', trigger: 'blur' }">
					<el-input v-model="formAdd.name" autocomplete="off" placeholder="分类名称"></el-input>
				</el-form-item>
				<el-form-item label="上级">
					<el-cascader
						:options="infos"
						:show-all-levels="false"
						:props="{ value: 'id', label: 'name', emitPath: false, checkStrictly: true }"
						v-model="formAdd.parentid"
						clearable
						placeholder="顶级分类"
					></el-cascader>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="showDialogAdd = false">取 消</el-button>
				<el-button type="primary" @click="formSubmitAdd('formAdd')">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="修改分类" :visible.sync="showDialogModify" width="400px">
			<el-form :model="formModify" ref="formModify" label-width="60px" label-suffix=":">
				<el-form-item label="名称" prop="name" :rules="{ required: true, message: '请输入名称', trigger: 'blur' }">
					<el-input v-model="formModify.name" autocomplete="off" placeholder="分类名称"></el-input>
				</el-form-item>
				<el-form-item label="上级">
					<el-cascader
						:options="infos"
						:show-all-levels="false"
						:props="{ value: 'id', label: 'name', emitPath: false, checkStrictly: true }"
						v-model="formModify.parentid"
						clearable
						placeholder="顶级分类"
					></el-cascader>
				</el-form-item>
				<el-form-item label="状态">
					<el-switch v-model="formModify.stateflag" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="showDialogModify = false">取 消</el-button>
				<el-button type="primary" @click="formSubmitModify('formModify')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loadingPage: false,
			infos: [],
			info_class: {},
			showDialogAdd: false,
			formAdd: {},
			showDialogModify: false,
			formModify: {}
		};
	},
	beforecreate: function() {},
	created: function() {
		this.loadingPage = true;
		this.$http.post('/server/index.php?m=contract/class/index&a=init', {}).then(
			res => {
				this.loadingPage = false;
				if (res.result == 'ok') {
					this.infos = res.data.infos;
					this.info_class = this.infos[0];
				} else {
					this.$alert(res.msg, {
						title: '操作错误',
						type: 'error'
					});
				}
			},
			r => {
				this.loadingPage = false;
				this.$alert('网络错误，指定的服务无法访问。', {
					title: '系统错误',
					type: 'error'
				});
			}
		);
	},
	mounted: function() {},
	updated: function() {},
	methods: {
		handleNodeClick(e) {
			this.info_class = e;
			this.formModify = e;
		},
		formSubmitAdd: function(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					if (this.formAdd.name == '') {
						this.$alert('请填写名称');
						return false;
					}
					const loading = this.$loading({
						lock: true,
						text: '处理中...',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					this.$http.post('/server/index.php?m=contract/class/index&a=add', this.formAdd).then(
						res => {
							loading.close();
							if (res.result == 'ok') {
								this.$alert('创建合同分类成功！', {
									title: '操作成功',
									type: 'success',
									callback: () => {
										this.$router.go(0);
									}
								});
							} else {
								this.$alert(res.msg, {
									title: '操作错误',
									type: 'error'
								});
							}
						},
						r => {
							loading.close();
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
						}
					);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		formSubmitModify: function(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					if (this.formModify.name == '') {
						this.$alert('请填写名称');
						return false;
					}
					const loading = this.$loading({
						lock: true,
						text: '处理中...',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					this.$http.post('/server/index.php?m=contract/class/index&a=modify', this.formModify).then(
						res => {
							loading.close();
							if (res.result == 'ok') {
								this.$alert('修改合同分类成功！', {
									title: '操作成功',
									type: 'success',
									callback: () => {
										this.$router.go(0);
									}
								});
							} else {
								this.$alert(res.msg, {
									title: '操作错误',
									type: 'error'
								});
							}
						},
						r => {
							loading.close();
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
						}
					);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		}
	}
};
</script>

<style>
.tree-line .el-tree-node {
	position: relative;
	padding-left: 10px;
}
.tree-line .el-tree-node__children {
	padding-left: 10px;
}
.tree-line .el-tree-node::before {
	content: '';
	height: 100%;
	width: 1px;
	position: absolute;
	left: -3px;
	top: -26px;
	border-width: 1px;
	border-left: 1px dashed #ddd;
}
.tree-line .el-tree-node:last-child::before {
	height: 38px;
}
.tree-line .el-tree-node::after {
	content: '';
	width: 24px;
	height: 20px;
	position: absolute;
	left: -3px;
	top: 12px;
	border-width: 1px;
	border-top: 1px dashed #ddd;
}
.tree-line > .el-tree-node::after {
	border-top: none;
}
.tree-line > .el-tree-node::before {
	border-left: none;
}
.tree-line .el-tree-node__expand-icon {
	font-size: 10px;
}
.tree-line .el-tree-node__expand-icon.is-leaf {
	color: transparent;
}
</style>
